import { Dispatch, FormEventHandler } from "react";
import { Button } from "@/components/ui/button";
import {
  FileUploadRoot,
  FileUploadTrigger,
} from "@/components/ui/file-upload";
import { Link, useNavigate } from "react-router-dom";
import { Flex } from "@chakra-ui/react";
import { MdCameraAlt, MdFileUpload } from "react-icons/md";

interface IRackPhoto {
  onOpenCamera: () => void;
  setImage: Dispatch<React.SetStateAction<File | undefined>>;
  backLink?: string;
}

function RackPhoto({ onOpenCamera, setImage, backLink }: IRackPhoto) {
  const navigate = useNavigate();
  const handleFileSelect: FormEventHandler<HTMLDivElement> = (e) => {
    const target = e.target as HTMLInputElement;
    if (target.files?.[0]) {
      const file = target.files[0];
      const ext = file.name.slice(file.name.lastIndexOf(".") + 1);
      setImage(
        new File([file], `${crypto.randomUUID()}/observation.${ext}`, {
          type: file.type,
          lastModified: file.lastModified,
        })
      );
    }
  };

  return (
    <Flex direction="column" alignItems="center" gap={4}>
      <Button w="full" colorPalette="blue" onClick={onOpenCamera} hideFrom="md">
        <MdCameraAlt /> Open Camera
      </Button>

      <FileUploadRoot onChange={handleFileSelect} accept="image/*">
        <FileUploadTrigger asChild>
          <Button w="full" variant="outline">
            <MdFileUpload /> Upload Photo
          </Button>
        </FileUploadTrigger>
      </FileUploadRoot>

      {backLink
        ? (
          <Link to={backLink} aria-label="Back to previous page">
            <Button variant="ghost" size="sm">
              Cancel
            </Button>
          </Link>
        )
        : (
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        )}
    </Flex>
  );
}

export default RackPhoto;
